import React from "react";

const Rule1 = ({ handleClose }) => {
  return (
    <>
      <div className="game-btn-rule">
        <button>Parity Rule</button>
      </div>

      <div>
        <h3>
          3 minutes 1 issue, 2 minutes and 57 seconds to order, 3 seconds to
          show the lottery result. It opens all day. The total number of trade
          is 480 issues.
        </h3>
        <h3>
          If you spend 100 rupees to trade, after deducting 5 rupees service
          fee, your contract amount is 95 rupees:
        </h3>
        <p>
        <span className="no-style">1</span>  JOIN GREEN: if the result shows 1,3,7,9, you will get (95*2) 190
          rupees; If the result shows 5, you will get (95*1.5) 142.5 rupees.
        </p>
        <p>
        <span className="no-style">2</span>  JOIN RED: if the result shows 2,4,6,8, you will get (95*2) 190
          rupees; If the result shows 0, you will get (95*1.5) 142.5 rupees.
        </p>
        <p>
        <span className="no-style">3</span>  JOIN VIOLET: if the result shows 0 or 5, you will get (95*4.5) 427.5
          rupees.
        </p>
      </div>

      <table className="table-rule">
        <tr className="td-row">
          <td className="hd-rule">Select</td>
          <td className="hd-rule">Result</td>
          <td className="hd-rule">Multiplier</td>
        </tr>
        <tr>
          <td rowspan="2" className="td-rule-green">
            Join Green{" "}
          </td>
          <td className="td-rule">1, 3, 7, 9</td>
          <td className="td-rule">2</td>
        </tr>
        <tr>
          <td className="td-rule">5</td>
          <td className="td-rule">1.5</td>
        </tr>
        <tr>
          <td rowspan="2" className="td-rule-red">
            Join Red
          </td>
          <td className="td-rule">2, 4, 6, 8</td>
          <td className="td-rule">2</td>
        </tr>
        <tr>
          <td className="td-rule">0</td>
          <td className="td-rule">1.5</td>
        </tr>
        <tr>
          <td className="hd-rule-violet">Join Violet</td>
          <td className="hd-rule">0, 5</td>
          <td className="hd-rule">4.5</td>
        </tr>
        <tr>
          <td className="hd-rule">Number</td>
          <td className="hd-rule">n</td>
          <td className="hd-rule">9</td>
        </tr>
      </table>
      <button onClick={handleClose} className="got-it-btn">
        I GOT IT
      </button>
    </>
  );
};

export default Rule1;
